import React from "react";
import Grid from "@mui/material/Grid";
import SnowIcon from "./SnowIcons.tsx";
import MultiLevelRose from "./MultiLevelRose.tsx";
import {
  isInvalidMultilevelRoseEntry,
  snowIconLabels,
} from "../utils/helpers.ts";

import "../snowreport.css";

type SnowTypeKey = keyof typeof snowIconLabels | string;

interface SnowTypeIconProps {
  type: SnowTypeKey;
}

function SnowTypeIcon({ type }: SnowTypeIconProps) {
  return (
    <div
      style={{ display: "flex", alignItems: "center", fontFamily: "Ubuntu" }}
    >
      <SnowIcon snowType={type as any} style={{ fontSize: 30 }} />
      <span style={{ marginLeft: "10px", fontSize: "16px" }}>
        {(snowIconLabels as Record<string, string>)[type as string]}
      </span>
    </div>
  );
}

interface SnowConditionEntryProps {
  snowConditionData: any;
  snowType?: SnowTypeKey;
  isFirstEntry?: boolean;
  cssIdentifier: string;
}

export function SnowConditionEntry(props: SnowConditionEntryProps) {
  if (
    isInvalidMultilevelRoseEntry(props.snowConditionData) ||
    !props.snowType
  ) {
    return <></>;
  }
  return (
    <>
      {props.isFirstEntry ? (
        <Grid
          size={{ xs: 12 }}
          style={{ padding: "0px", marginTop: "5px" }}
        ></Grid>
      ) : (
        <Grid size={{ xs: 12 }} style={{ padding: "0px", marginTop: "5px" }}>
          <hr style={{ border: "1px solid black", margin: "0 0 10px 10px" }} />
        </Grid>
      )}

      <div>
        <Grid container>
          <Grid
            size={{ xs: 12, sm: 5 }}
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <SnowTypeIcon type={props.snowType} />
          </Grid>
          <Grid container size={{ xs: 12, sm: 7 }}>
            <Grid
              size={{ xs: 12 }}
              style={{
                marginBottom: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MultiLevelRose
                conditionData={props.snowConditionData}
                cssIdentifier={props.cssIdentifier}
                width={"120px"}
                height={"100px"}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default SnowConditionEntry;
